var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      staticClass: "g-input",
      staticStyle: { "padding-right": "10px" },
      attrs: {
        error: _vm.$v.dValue.$error,
        "error-label": _vm.mensagemErro,
        count: _vm.dTamanho,
        disabled: _vm.desabilitar,
        helper: _vm.mensagemAjuda
      }
    },
    [
      _c("q-input", {
        attrs: {
          value: _vm.value,
          name: _vm.name,
          id: _vm.id,
          "float-label": _vm.etiqueta,
          disable: _vm.desabilitar,
          type: _vm.tipo,
          color: _vm.cor,
          align: _vm.alinhar,
          "no-pass-toggle": true,
          "min-rows": _vm.linhasMinimo,
          inverted: _vm.invertido,
          "max-height": _vm.alturaMaxima,
          maxlength: _vm.dTamanho,
          autofocus: _vm.foco
        },
        on: {
          input: function($event) {
            _vm.atualizarModelo($event)
          },
          blur: _vm.validar,
          keyup: function($event) {
            if (!("button" in $event) && $event.keyCode !== 13) {
              return null
            }
            return _vm.chamarFuncaoNoEnter($event)
          },
          keydown: _vm.validaInsercaoNoKeydown,
          change: _vm.change
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }